import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-h2h',
    templateUrl: './default/h2h/h2h.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class H2hComponent extends UnitsDistributionBase {
  // Used for TENNIS_H2H
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}